import React, { Component } from 'react';
import ResultCard from '../components/result_card';
import LoadCard from '../components/loadcard';

class SearchResults extends Component {
  constructor(props){
    super(props);
    this.state = {
      rand_array: props.data.rand_array,
      results: props.data.results
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({
      results: props.data.results,
      rand_array: props.data.rand_array
    })
  }

  whichFav(){
    var nav_sel = this.props.data.nav_selection
    var relavent_fav_dict;
    switch(nav_sel){
      case "hotels":
      relavent_fav_dict = this.props.data.hotel_favs
      break;
      case "attractions":
      relavent_fav_dict = this.props.data.attraction_favs
      break;
      case "restaurants":
      relavent_fav_dict = this.props.data.restaurant_favs
      break;
      default:
      console.log("no fav dict selected")
    }
    return(relavent_fav_dict)
  }

  searchResults(dataArray) {
    let results;
    if(dataArray.length === 0){
      results = <LoadCard key={0} data={this.props.data} />
    } else {
      results = dataArray.map((result, ndx)=>
        <ResultCard key={result.entity_id}
        nav_selection= {this.props.data.nav_selection}
        favorites = {this.whichFav()}
        data={result}
        image={result.image}
        eventLogToServer = {this.props.eventLogToServer}
        query_hovered={this.props.data.query_hovered}
        query_terms={this.props.data.query_terms}
        hover_active={this.props.data.hover_active}
        trigger_fadein={this.props.data.trigger_fadein}
        updateFavorites={this.props.updateFavorites}
        renderRevSummary={this.props.renderRevSummary}
        />);
    }
    return results;
  }

  render() {
    const results = this.props.data.results;
    var per_result = [];
    if (results) {
      per_result = this.searchResults(results);
    }
    return(
      <div>
        { per_result }
      </div>
    );
  }

}


export default SearchResults;
